import {NgModule} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import {loginComponent} from "./login.component";
import {ReactiveFormsModule, FormsModule} from '@angular/forms';
import {RouterModule} from "@angular/router";
import {AuthService} from "../../models/auth/auth.service";

@NgModule({
    declarations: [loginComponent],
    imports     : [
        BrowserModule,
        ReactiveFormsModule,
        RouterModule,
        FormsModule,
    ],
    providers: [
        AuthService,
    ]
})

export class LoginModule {}


// WEBPACK FOOTER //
// ./src/app/views/login/login.module.ts